import React, { FunctionComponent, Dispatch, SetStateAction } from "react";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Lightbox from "react-image-lightbox";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    marginTop: 30
  },
  media: {
    height: 140
  }
});

interface ImagesShopProps {
  images: string[];
  imageIndex: number;
  title: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  setImageIndex: Dispatch<SetStateAction<number>>;
  onBuy?: () => void;
  isBought: boolean;
}

export const ImagesShop: FunctionComponent<ImagesShopProps> = props => {
  const classes = useStyles();
  window.onpopstate = (e: any) => {
    e.preventDefault();
    if (props.isOpen) {
      props.setIsOpen(false);
      window.history.forward();
    }
  };
  return (
    <Card className={classes.root}>
      {props.isOpen && (
        <Lightbox
          mainSrc={props.images[props.imageIndex]}
          nextSrc={props.images[(props.imageIndex + 1) % props.images.length]}
          prevSrc={
            props.images[
              (props.imageIndex + props.images.length - 1) % props.images.length
            ]
          }
          onCloseRequest={() => props.setIsOpen(false)}
          onMovePrevRequest={() =>
            props.setImageIndex(
              (props.imageIndex + props.images.length - 1) % props.images.length
            )
          }
          onMoveNextRequest={() =>
            props.setImageIndex((props.imageIndex + 1) % props.images.length)
          }
        />
      )}
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={`${props.images[props.imageIndex]}`}
          title={props.title}
          onClick={() => props.setIsOpen(true)}
        />
        <CardContent onClick={() => props.setIsOpen(true)}>
          <Typography gutterBottom variant="h5" component="h2">
            {props.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            There are {props.images.length} images on this package.
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          size="small"
          color="primary"
          onClick={() => props.setIsOpen(true)}
        >
          Show
        </Button>
        {!props.isBought && (
          <Button
            size="small"
            color="primary"
            onClick={() => props.onBuy && props.onBuy()}
          >
            Buy
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
